/**
 *	(c) 2024 Приволжский Исследовательский Медицинский Университет
 *
 *	@file: Footer.js
 *  @description: Этот файл является частью клиентской стороны проекта. src Относится к части, которая содержит компоненты - части страниц, допускающие многократное использование в разных частях. Footer.js
 *	@author: Манжос Геннадий Юрьевич, Горбас Александр Петрович, Белов Михаил Александрович
*/
import { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Context } from '../index';

import './Footer.css'

const Footer = observer(() => {
    const { user } = useContext(Context);
    const { t } = useTranslation();

    //  Роль пользователя. Если её нет - то пользователь демо.
    const userRole = user.profile.role ?? 'demo';

    const currentYear = new Date().getFullYear();

    const logOut = () => {
        user.setUser({});
        user.setIsAuth(false);

        localStorage.removeItem('token');
    };

    return (
        <div className='footer'>
            <div className={ 'footer_top_section lang_' + user.language }>
                <a href='https://futuredoc.minzdrav.gov.ru/' target='_blank' rel='noopener noreferrer'>
                    <img className='icon_footer' src='/icons/futuredoc.png' alt='futuredoc' />
                </a>
                <img className='icon_footer' src={t('logo_pic_about')} alt='icon_footer' />
            </div>
            <div className='footer_grid'>
                <div className='menu_block_footer'>
                    <div className='footer_title'>
                        {t('footer_title_option')}
                    </div>
                    <ul className='list-unstyled'>
                        <li>
                            <a href='https://med-atlas.site/pimu' className='footer_text'>
                                {t('footer_title_menu')}
                            </a>
                        </li>
                        <li>
                            <a href='https://med-atlas.site/' className='footer_text'>
                                {t('navbar_title_main')}
                            </a>
                        </li>
                        {user.isAuth && userRole !== 'demo' ? <>
                            <li><a href='https://med-atlas.site/account' className='footer_text'>{t('navbar_title_account')}</a></li>
                            <li><a href='https://med-atlas.site/' onClick={() => logOut()} className='footer_text'>{t('navbar_title_authorization_logout')}</a></li>
                        </> :
                            <li><a href='https://med-atlas.site/' className='footer_text'>{t('navbar_title_authorization_login')}</a></li>
                        }
                    </ul>
                </div>
                <div className='documentation_block_footer'>
                    <div className='footer_title'>
                        {t('footer_title_option_documentation')}
                    </div>
                    <ul className='list-unstyled'>
                        <li>
                            <a href='https://med-atlas.site/about_application' className='footer_text'>
                                {t('navbar_title_about')}
                            </a>
                        </li>
                        <li>
                            <a href='https://med-atlas.site/terms' className='footer_text'>
                                {t('footer_title_terms')}
                            </a>
                        </li>
                        <li>
                            <a href='https://med-atlas.site/system_requirements' className='footer_text'>
                                {t('System requirements')}
                            </a>
                        </li>
                        <li>
                            <a href='https://med-atlas.site/support' className='footer_text'>
                                {t('navbar_title_support')}
                            </a>
                        </li>
                        <li>
                            <a href='https://med-atlas.site/agreement' className='footer_text'>
                                {t('navbar_title_agreement')}
                            </a>
                        </li>
                    </ul>
                </div>
                <div className='contacts_block_footer'>
                    <div className='footer_title'>
                        {t('footer_title_option_contacts')}
                    </div>
                    <ul className='list-unstyled'>
                        <li>
                            <a href='mailto:sale@pimunn.net' className='footer_text'>
                                {t('footer_title_option_mail')}
                            </a>
                        </li>
                        <li></li>
                    </ul>
                </div>
                <div className='subscribe_block_footer'>
                    <div className='footer_title'>
                        {t('footer_title_option_subscribe')}
                    </div>
                    <ul className='list-unstyled'>
                        <li>
                            <a href='https://med-atlas.site/subscribe' className='footer_text'>
                                {t('navbar_title_subsribe')}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <hr className='hr_copyright'></hr>
            <div className='d-flex justify-content-center'>
                <div className='copyright'>
                    <p>
                        {t('start_page_title')} © {t('footer_title_copyright')} {currentYear}
                    </p>
                </div>
            </div>
        </div >
    );
});

export default Footer;
